export default {
  learningExperiencesTitle: 'Learning experiences: {code} - {name}',
  learningExperiencesPrintTitle: 'Learning experiences - {code} {name}',
  learningExperience: 'Learning experience',
  summativeAndFormativeActivitiesAndEvaluations: 'Summative and formative activities and evaluations',
  numberAndNameEA: 'No. and NAME LE',
  learningOutcomes: 'Learning result(s)',
  descriptionHeader: 'DESCRIPTION (Purpose, methodology, evaluations, environments, times and resources)',
  numberAndNameDirectedTeachingActivity: 'No. and NAME DIRECTED TEACHING ACTIVITY',
  briefDescriptionForTeacher: 'Brief description FOR THE TEACHER',
  briefDescriptionForStudent: 'Brief description FOR THE TEACHER',
  connectionWithEnvironment: 'Connection with the environment',
  achievementIndicators: 'Achievement indicator(s)',
  directedTeachingHours: 'Directed teaching hours',
  pedagogicalHours: 'Pedagogical hours',
  autonomousWorkActivity: 'Student autonomous work activity',
  autonomousWorkHours: 'Autonomous work hours',
  chronologicalHours: 'Chronological hours',
  learningResources: 'Learning resources',
  learningResourcesSubtitle: '(Interactive PPT, Videos, Tutorials, Links, Podcast, etc)',
  learningResourcesSubtitle2: '(Guides, Instructions, Evaluation Rubrics)',
  educationalTechnology: 'Educational technology',
  educationalTechnologySubtitle: 'Kaltura, C1DO1, Software, Web Applications (MIRO, Mentimeter, Jamboard)',
  mandatoryBibliography: 'Mandatory bibliography',
  mandatoryBibliographySubtitle: 'Include chapter numbers and page numbers.',
  supplementaryBibliography: 'Supplementary bibliography',
  learningEnvironments: 'Learning environments',
  numberOfStudents: 'No. of students',
  downloadXLS: 'Download XLS',
  eaPrefix: 'LE',
  raPrefix: 'LO',
  transversalExam: 'Transversal Exam',
  noLearningExperiencesRecord: 'There are no learning experience records for this {entity}.',
}
